import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
var _excluded = ["text", "buttonAttributes"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import { Container } from "../../Container/Container/Container";
import { MastheadCardGrid } from "../../Grid/MastheadCardGrid/MastheadCardGrid";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Background } from "../../Background/Background";
import { Text } from "../../Text/Text/Text";
import styles from "./MastheadGridSlice.module.scss";
import { Button } from "../../Button/Button/Button";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var mastheadGridAlign = ['left', 'center'];
export var mastheadGridEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3', 'headline7'];
var renderEyebrow = function renderEyebrow(eyebrow) {
  var _ref = eyebrow !== null && eyebrow !== void 0 ? eyebrow : {},
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$typog = _ref.typog,
    typog = _ref$typog === void 0 ? 'headline7' : _ref$typog;
  return /*#__PURE__*/_jsx(Text, {
    className: styles.eyebrow,
    typog: typog,
    children: text
  });
};
var renderHeading = function renderHeading(heading, align) {
  var _ref2 = heading !== null && heading !== void 0 ? heading : {},
    _ref2$ariaLevel = _ref2.ariaLevel,
    ariaLevel = _ref2$ariaLevel === void 0 ? 2 : _ref2$ariaLevel,
    _ref2$text = _ref2.text,
    text = _ref2$text === void 0 ? '' : _ref2$text,
    _ref2$typog = _ref2.typog,
    typog = _ref2$typog === void 0 ? 'headline2' : _ref2$typog;
  return /*#__PURE__*/_jsx(HeadingText, {
    ariaLevel: ariaLevel,
    typog: typog,
    richText: true,
    className: styles.heading,
    align: align,
    children: text
  }, "heading");
};
var renderBodyText = function renderBodyText(bodyText) {
  var _ref3 = bodyText !== null && bodyText !== void 0 ? bodyText : {},
    _ref3$text = _ref3.text,
    text = _ref3$text === void 0 ? '' : _ref3$text,
    _ref3$typog = _ref3.typog,
    typog = _ref3$typog === void 0 ? 'bodycopy' : _ref3$typog,
    _ref3$large = _ref3.large,
    large = _ref3$large === void 0 ? false : _ref3$large;
  return /*#__PURE__*/_jsx(Text, {
    className: classnames([large ? styles.textLarge : undefined, styles.bodyCopy]),
    typog: typog,
    richText: true,
    children: text
  });
};
var renderMastheadGridCards = function renderMastheadGridCards() {
  var mastheadGridCards = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var gridAlignment = arguments.length > 1 ? arguments[1] : undefined;
  return /*#__PURE__*/_jsx("div", {
    className: styles.gridWrapper,
    children: /*#__PURE__*/_jsx(MastheadCardGrid, {
      cardList: mastheadGridCards,
      gridAlignment: gridAlignment
    })
  });
};
var renderCTA = function renderCTA(cta) {
  var _ref4 = cta !== null && cta !== void 0 ? cta : {},
    text = _ref4.text,
    _ref4$buttonAttribute = _ref4.buttonAttributes,
    buttonAttributes = _ref4$buttonAttribute === void 0 ? {} : _ref4$buttonAttribute,
    otherProps = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    attributes: buttonAttributes
  }, otherProps), {}, {
    children: text
  }));
};
export var MastheadGridSlice = function MastheadGridSlice(_ref5) {
  var _ref5$align = _ref5.align,
    align = _ref5$align === void 0 ? 'center' : _ref5$align,
    _ref5$background = _ref5.background,
    background = _ref5$background === void 0 ? {} : _ref5$background,
    _ref5$eyebrow = _ref5.eyebrow,
    eyebrow = _ref5$eyebrow === void 0 ? {
      text: '',
      typog: 'headline7'
    } : _ref5$eyebrow,
    _ref5$heading = _ref5.heading,
    heading = _ref5$heading === void 0 ? {
      ariaLevel: 2,
      text: '',
      typog: 'headline3',
      variant: 'default'
    } : _ref5$heading,
    _ref5$bodyText = _ref5.bodyText,
    bodyText = _ref5$bodyText === void 0 ? {
      text: '',
      typog: 'bodycopy',
      large: false
    } : _ref5$bodyText,
    mastheadCards = _ref5.mastheadCards,
    _ref5$gridAlignment = _ref5.gridAlignment,
    gridAlignment = _ref5$gridAlignment === void 0 ? 'center' : _ref5$gridAlignment,
    _ref5$cta = _ref5.cta,
    cta = _ref5$cta === void 0 ? {
      url: '',
      text: '',
      type: 'primary',
      newWindow: false,
      buttonAttributes: {}
    } : _ref5$cta;
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.mastheadGrid,
        children: [/*#__PURE__*/_jsxs("div", {
          className: align && (eyebrow && eyebrow.text || heading && heading.text) ? classnames(styles.header, styles["mastheadGridHeaderAlign".concat(_capitalize(align))]) : undefined,
          children: [(eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && (eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.typog) && renderEyebrow(eyebrow), (heading === null || heading === void 0 ? void 0 : heading.text) && (heading === null || heading === void 0 ? void 0 : heading.typog) && renderHeading(heading, align), (bodyText === null || bodyText === void 0 ? void 0 : bodyText.text) && renderBodyText(bodyText)]
        }), mastheadCards && mastheadCards.length && renderMastheadGridCards(mastheadCards, gridAlignment)]
      }), (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url) && /*#__PURE__*/_jsx("div", {
        className: styles.cta,
        children: renderCTA(cta)
      })]
    })
  }));
};